import { render, staticRenderFns } from "./projectReviewGcTabFile.vue?vue&type=template&id=400456e2&"
import script from "./projectReviewGcTabFile.vue?vue&type=script&lang=js&"
export * from "./projectReviewGcTabFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports